import { Injectable } from '@angular/core';
import { ContextMenu } from 'primeng/contextmenu';

@Injectable({
    providedIn: 'root'
})
export class ContextMenuService {

    private _contextMenus: ContextMenu[] = [];

    public addContextMenu(cm: ContextMenu) {
        cm.onShow.subscribe(() => {
            this._contextMenus.forEach(x => x.hide());
            this._contextMenus.push(cm);
        });
        cm.onHide.subscribe(() => this._contextMenus = this._contextMenus.filter(x => x !== cm));
    }
}